// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Case Optimization & Coverage Analysis Styles */

/* Requirement-to-Test Mapping Styles */
.mapping-tabs {
  display: flex;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.mapping-tab-button {
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.mapping-tab-button.active {
  color: #3b82f6;
}

.mapping-tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #3b82f6;
}

.mapping-tab-button:hover:not(.active) {
  color: #4b5563;
  background-color: #f9fafb;
}

.traceability-matrix {
  margin-bottom: 2rem;
}

/* Matrix Controls */
.matrix-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.matrix-filter {
  display: flex;
  gap: 0.5rem;
}

.matrix-filter-input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  width: 200px;
  font-size: 0.875rem;
}

.matrix-filter-button {
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
}

.matrix-filter-button:hover {
  background-color: #e5e7eb;
}

.matrix-view-options {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.view-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #4b5563;
}

.view-option input[type="radio"] {
  margin: 0;
}

/* Matrix Table */
.matrix-container {
  overflow: auto;
  max-height: 600px;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

/* Grid View */
.grid-view .matrix-table {
  width: 100%;
  border-collapse: collapse;
}

/* Compact View */
.compact-view .matrix-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.compact-view .matrix-cell {
  padding: 0.5rem 0.25rem;
}

.compact-view .coverage-block {
  width: 16px;
  height: 16px;
}

.compact-view .requirement-cell {
  max-width: 200px;
}

.compact-view .requirement-description {
  display: none;
}

.compact-view .tc-header {
  width: 30px;
}

.matrix-header-cell {
  position: sticky;
  top: 0;
  background-color: #f9fafb;
  padding: 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4b5563;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
}

.requirements-header {
  text-align: left;
  width: 250px;
}

.tc-header {
  width: 50px;
}

.coverage-header {
  width: 100px;
}

.matrix-row:hover {
  background-color: #f9fafb;
}

.matrix-cell {
  padding: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
  vertical-align: middle;
}

.requirement-cell {
  text-align: left;
}

.coverage-indicator-cell {
  padding: 0.5rem;
}

.coverage-cell-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coverage-block {
  width: 24px;
  height: 24px;
  margin: 0 auto;
  border-radius: 4px;
}

.coverage-block.covered {
  background-color: rgba(16, 185, 129, 0.2);
}

.coverage-block.not-covered {
  background-color: rgba(239, 68, 68, 0.1);
}

.coverage-block.empty {
  background-color: transparent;
}

.coverage-actions {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 4px;
  margin-top: 4px;
}

.coverage-cell-content:hover .coverage-actions {
  display: flex;
}

.action-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px;
  margin: 0 2px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.action-icon:hover {
  background-color: #f3f4f6;
}

.coverage-cell {
  width: 100px;
}

.coverage-bar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.coverage-bar {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.coverage-bar-fill {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 4px;
}

.coverage-percentage {
  font-size: 0.75rem;
  font-weight: 600;
  color: #4b5563;
}

.requirement-cell {
  text-align: left;
  padding: 0.75rem;
}

.requirement-title {
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

.requirement-description {
  font-size: 0.75rem;
  color: #6b7280;
}

.coverage-indicator {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.coverage-bar {
  width: 100%;
  height: 6px;
  background-color: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}

.coverage-bar-fill {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 3px;
}

.coverage-percentage {
  font-size: 0.75rem;
  font-weight: 600;
  color: #4b5563;
  text-align: center;
}

/* Pagination */
.matrix-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
}

.pagination-button {
  padding: 0.5rem 1rem;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
}

.pagination-button:hover:not(:disabled) {
  background-color: #e5e7eb;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  font-size: 0.875rem;
  color: #6b7280;
}

/* Matrix Legend */
.matrix-legend {
  display: flex;
  gap: 2rem;
  justify-content: center;
  padding: 0.75rem;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.legend-color.covered {
  background-color: rgba(16, 185, 129, 0.2);
}

.legend-color.not-covered {
  background-color: rgba(239, 68, 68, 0.1);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  /* width: 90%; */
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #1f2937;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
}

.modal-body {
  padding: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #4b5563;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
}

.save-button, .cancel-button, .apply-suggestion-button {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}

.save-button {
  background-color: #3b82f6;
  color: white;
  border: none;
}

.save-button:hover {
  background-color: #2563eb;
}

.cancel-button {
  background-color: #f3f4f6;
  color: #4b5563;
  border: 1px solid #d1d5db;
}

.cancel-button:hover {
  background-color: #e5e7eb;
}

/* AI Suggestions Styles */
.test-case-details {
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
}

.test-case-details h4 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  color: #1f2937;
}

.test-case-details p {
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

.ai-suggestions h4 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #1f2937;
}

.suggestion-category {
  margin-bottom: 1.5rem;
}

.suggestion-category h5 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  color: #4b5563;
  font-size: 0.875rem;
  font-weight: 600;
}

.suggestion-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f3f4f6;
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
}

.suggestion-item p {
  margin: 0;
  font-size: 0.875rem;
  color: #4b5563;
  flex: 1 1;
}

.apply-suggestion-button {
  background-color: #10b981;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
}

.apply-suggestion-button:hover {
  background-color: #059669;
}

.uncovered-requirements {
  margin-top: 1.5rem;
}

.requirements-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.requirement-item {
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1rem;
}

.requirement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.requirement-header h5 {
  margin: 0;
  font-size: 1rem;
  color: #1f2937;
}

.requirement-item .action-link {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.requirement-item .action-link:hover {
  background-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: white;
}

.requirement-item .action-link:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.requirement-item .action-link::before {
  content: '\\f0ae';  /* Font Awesome icon code for tasks */
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}

/* Generate Test Cases Button Styles */
.action-link {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-link:hover {
  background-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-link:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.action-link::before {
  content: '\\f0ae';  /* Font Awesome icon code for tasks */
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}

/* No Project Message Styles */
.no-project-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  background-color: #f9fafb;
  border-radius: 0.5rem;
  border: 1px dashed #d1d5db;
  margin: 2rem 0;
  text-align: center;
}

.message-icon {
  font-size: 2.5rem;
  color: #9ca3af;
  margin-bottom: 1rem;
}

.no-project-message h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.no-project-message p {
  color: #6b7280;
  max-width: 400px;
  font-size: 0.875rem;
}

/* Project Selector Styles */
.project-selector {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  background-color: var(--surface-2, #f9fafb);
  border-radius: 0.5rem;
  border: 1px solid var(--border, #e5e7eb);
}

.project-selector label {
  font-weight: 500;
  color: var(--text-secondary, #4b5563);
  flex-shrink: 0;
}

.project-select {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: white;
  font-size: 0.875rem;
  min-width: 200px;
  color: #1f2937;
  cursor: pointer;
}

.project-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
}

.project-picker {
  position: relative;
  flex: 1 1;
  min-width: 240px;
  max-width: 420px;
}

.project-picker__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border, #d1d5db);
  background: var(--surface, #fff);
  color: var(--text-primary, #1f2937);
  font-size: 0.875rem;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}

.project-picker__trigger.is-open,
.project-picker__trigger:focus-visible {
  outline: none;
  border-color: var(--primary, #3b82f6);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary, #3b82f6) 25%, transparent);
}

.project-picker__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.project-picker__actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-muted, #6b7280);
  flex-shrink: 0;
}

.project-picker__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  color: var(--text-muted, #6b7280);
}

.project-picker__clear:hover {
  background: color-mix(in srgb, var(--text-primary, #0f172a) 8%, transparent);
  color: var(--text-primary, #111827);
}

.project-picker__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 40;
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.14);
  overflow: hidden;
}

.project-picker__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border, #e5e7eb);
  color: var(--text-muted, #6b7280);
}

.project-picker__search input {
  flex: 1 1;
  min-width: 0;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 0.875rem;
  font-family: inherit;
  color: var(--text-primary, #111827);
  padding: 0 !important;
}

.project-picker__search input[type='search']::-webkit-search-cancel-button {
  appearance: none;
}

.project-picker__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 12px;
  font-size: 11px;
  color: var(--text-muted, #6b7280);
  border-bottom: 1px solid var(--border-subtle, #f1f5f9);
}

.project-picker__scope {
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-size: 10px;
}

.project-picker__list {
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
}

.project-picker__option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  color: var(--text-primary, #111827);
}

.project-picker__option:hover,
.project-picker__option.is-active {
  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);
}

.project-picker__option-name {
  font-size: 0.875rem;
  font-weight: 550;
}

.project-picker__option-desc {
  font-size: 11px;
  color: var(--text-muted, #6b7280);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.project-picker__empty {
  padding: 16px 10px;
  text-align: center;
  font-size: 0.8125rem;
  color: var(--text-muted, #6b7280);
}

.project-picker__retry {
  margin-left: 8px;
  border: none;
  background: transparent;
  color: var(--primary, #2563eb);
  cursor: pointer;
  font-size: 0.8125rem;
  font-family: inherit;
  text-decoration: underline;
}

.selected-project-info {
  margin-left: 1rem;
  padding-left: 1rem;
  border-left: 1px solid #e5e7eb;
}

.project-description {
  font-size: 0.875rem;
  color: #6b7280;
  font-style: italic;
}

.optimization-container {
  padding: 1.5rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.optimization-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.optimization-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 1rem;
}

.optimization-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
}

.tab-container {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1.5rem;
}

.tab-button {
  padding: 0.75rem 1rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: none;
  transition: all 0.2s;
}

.tab-button.active {
  color: #3b82f6;
  border-bottom: 2px solid #3b82f6;
}

.tab-button:not(.active) {
  color: #6b7280;
}

.tab-button:hover:not(.active) {
  color: #4b5563;
  background-color: #f9fafb;
}

.tab-content {
  padding: 1rem 0;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1f2937;
}

.control-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.threshold-control {
  display: flex;
  align-items: center;
}

.threshold-label {
  margin-right: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
}

.threshold-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
}

.analyze-button {
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.analyze-button:hover:not(:disabled) {
  background-color: #2563eb;
}

.analyze-button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}

.content-panel {
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 0.5rem;
}

.info-text {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.duplicate-group {
  margin-bottom: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
}

.duplicate-header {
  background-color: #f3f4f6;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.duplicate-title {
  font-weight: 500;
  color: #1f2937;
}

.similarity-badge {
  font-size: 0.75rem;
  color: #6b7280;
  margin-left: 0.5rem;
}

.merge-button {
  padding: 0.25rem 0.75rem;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.merge-button:hover {
  background-color: #059669;
}

.test-case-item {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border, #e5e7eb);
}

.test-case-item:last-child {
  border-bottom: none;
}

/* Scope hover to optimization page only — do not bleach modal cards in dark mode */
.optimization-container .test-case-item:hover,
.mapping-results .test-case-item:hover {
  background-color: var(--surface-hover, #f9fafb);
}

.test-case-title {
  font-weight: 500;
  color: var(--text-primary, #1f2937);
}

.test-case-id {
  font-size: 0.75rem;
  color: #6b7280;
}

.empty-state {
  text-align: center;
  padding: 2rem 0;
  color: #6b7280;
}

/* Coverage Analysis Styles */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.stat-card {
  background-color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.stat-value {
  font-size: 1.875rem;
  font-weight: 700;
}

.stat-value.primary {
  color: #3b82f6;
}

.stat-value.success {
  color: #10b981;
}

.stat-value.warning {
  color: #f59e0b;
}

.stat-label {
  font-size: 0.75rem;
  color: #6b7280;
}

.progress-item {
  margin-bottom: 0.5rem;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.progress-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
}

.progress-value {
  font-size: 0.875rem;
  color: #6b7280;
}

.progress-bar-bg {
  width: 100%;
  height: 0.5rem;
  background-color: #e5e7eb;
  border-radius: 9999px;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 9999px;
}

.progress-bar-fill.high {
  background-color: #10b981;
}

.progress-bar-fill.medium {
  background-color: #f59e0b;
}

.progress-bar-fill.low {
  background-color: #ef4444;
}

/* User Story Relationship Styles */
.story-card {
  margin-bottom: 1.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
}

.story-header {
  background-color: #eff6ff;
  padding: 1rem;
}

.story-title {
  font-weight: 500;
  color: #1e40af;
}

.story-description {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

.story-content {
  padding: 1rem;
}

.related-tests-title {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #1f2937;
}

.related-tests-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.related-test-item {
  background-color: white;
  padding: 0.75rem;
  border-radius: 0.25rem;
  border: 1px solid #e5e7eb;
}

.related-test-title {
  font-weight: 500;
  color: #1f2937;
}

.related-test-meta {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 9999px;
  line-height: 1.25rem;
}

.status-badge.passed {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.failed {
  background-color: #fee2e2;
  color: #991b1b;
}

.priority-label {
  margin-left: 0.5rem;
}

/* Table Styles */
.table-container {
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.table {
  min-width: 100%;
  border-collapse: collapse;
}

.table-header {
  background-color: #f9fafb;
}

.table-header-cell {
  padding: 0.75rem 1.5rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.table-row {
  border-top: 1px solid #e5e7eb;
}

.table-cell {
  padding: 1rem 1.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
}

.table-cell.primary {
  font-weight: 500;
  color: #1f2937;
}

.table-cell.secondary {
  color: #6b7280;
}

/* Generate Test Cases button in table */
.table-cell .action-link {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.table-cell .action-link:hover {
  background-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: white;
}

.table-cell .action-link:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.table-cell .action-link::before {
  content: '\\f0ae';  /* Font Awesome icon code for tasks */
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/test-case-optimization.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB,GAAG,qCAAqC;EACxD,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB,GAAG,qCAAqC;EACxD,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,2CAA2C;EAC3C,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,kFAAkF;AACpF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,4EAA4E;EAC5E,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;;EAEE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB,GAAG,qCAAqC;EACxD,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":["/* Test Case Optimization & Coverage Analysis Styles */\n\n/* Requirement-to-Test Mapping Styles */\n.mapping-tabs {\n  display: flex;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.mapping-tab-button {\n  padding: 0.75rem 1.5rem;\n  background: none;\n  border: none;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.mapping-tab-button.active {\n  color: #3b82f6;\n}\n\n.mapping-tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #3b82f6;\n}\n\n.mapping-tab-button:hover:not(.active) {\n  color: #4b5563;\n  background-color: #f9fafb;\n}\n\n.traceability-matrix {\n  margin-bottom: 2rem;\n}\n\n/* Matrix Controls */\n.matrix-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.matrix-filter {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.matrix-filter-input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.25rem;\n  width: 200px;\n  font-size: 0.875rem;\n}\n\n.matrix-filter-button {\n  padding: 0.5rem 1rem;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.matrix-filter-button:hover {\n  background-color: #e5e7eb;\n}\n\n.matrix-view-options {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.view-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.view-option input[type=\"radio\"] {\n  margin: 0;\n}\n\n/* Matrix Table */\n.matrix-container {\n  overflow: auto;\n  max-height: 600px;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Grid View */\n.grid-view .matrix-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* Compact View */\n.compact-view .matrix-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.compact-view .matrix-cell {\n  padding: 0.5rem 0.25rem;\n}\n\n.compact-view .coverage-block {\n  width: 16px;\n  height: 16px;\n}\n\n.compact-view .requirement-cell {\n  max-width: 200px;\n}\n\n.compact-view .requirement-description {\n  display: none;\n}\n\n.compact-view .tc-header {\n  width: 30px;\n}\n\n.matrix-header-cell {\n  position: sticky;\n  top: 0;\n  background-color: #f9fafb;\n  padding: 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #4b5563;\n  border-bottom: 1px solid #e5e7eb;\n  text-align: center;\n}\n\n.requirements-header {\n  text-align: left;\n  width: 250px;\n}\n\n.tc-header {\n  width: 50px;\n}\n\n.coverage-header {\n  width: 100px;\n}\n\n.matrix-row:hover {\n  background-color: #f9fafb;\n}\n\n.matrix-cell {\n  padding: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.requirement-cell {\n  text-align: left;\n}\n\n.coverage-indicator-cell {\n  padding: 0.5rem;\n}\n\n.coverage-cell-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.coverage-block {\n  width: 24px;\n  height: 24px;\n  margin: 0 auto;\n  border-radius: 4px;\n}\n\n.coverage-block.covered {\n  background-color: rgba(16, 185, 129, 0.2);\n}\n\n.coverage-block.not-covered {\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n.coverage-block.empty {\n  background-color: transparent;\n}\n\n.coverage-actions {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  padding: 4px;\n  margin-top: 4px;\n}\n\n.coverage-cell-content:hover .coverage-actions {\n  display: flex;\n}\n\n.action-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 4px;\n  margin: 0 2px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.action-icon:hover {\n  background-color: #f3f4f6;\n}\n\n.coverage-cell {\n  width: 100px;\n}\n\n.coverage-bar-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.coverage-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.coverage-bar-fill {\n  height: 100%;\n  background-color: #3b82f6;\n  border-radius: 4px;\n}\n\n.coverage-percentage {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #4b5563;\n}\n\n.requirement-cell {\n  text-align: left;\n  padding: 0.75rem;\n}\n\n.requirement-title {\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 0.25rem;\n}\n\n.requirement-description {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.coverage-indicator {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.coverage-bar {\n  width: 100%;\n  height: 6px;\n  background-color: #e5e7eb;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.coverage-bar-fill {\n  height: 100%;\n  background-color: #3b82f6;\n  border-radius: 3px;\n}\n\n.coverage-percentage {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #4b5563;\n  text-align: center;\n}\n\n/* Pagination */\n.matrix-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.pagination-button {\n  padding: 0.5rem 1rem;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: #e5e7eb;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n/* Matrix Legend */\n.matrix-legend {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  padding: 0.75rem;\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  margin-top: 1rem;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.legend-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n}\n\n.legend-color.covered {\n  background-color: rgba(16, 185, 129, 0.2);\n}\n\n.legend-color.not-covered {\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */\n  /* width: 90%; */\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  color: #1f2937;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.modal-body {\n  padding: 1rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #4b5563;\n}\n\n.form-control {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n}\n\n.save-button, .cancel-button, .apply-suggestion-button {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.save-button {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n}\n\n.save-button:hover {\n  background-color: #2563eb;\n}\n\n.cancel-button {\n  background-color: #f3f4f6;\n  color: #4b5563;\n  border: 1px solid #d1d5db;\n}\n\n.cancel-button:hover {\n  background-color: #e5e7eb;\n}\n\n/* AI Suggestions Styles */\n.test-case-details {\n  background-color: #f9fafb;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.test-case-details h4 {\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  color: #1f2937;\n}\n\n.test-case-details p {\n  margin: 0.5rem 0;\n  font-size: 0.875rem;\n}\n\n.ai-suggestions h4 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  color: #1f2937;\n}\n\n.suggestion-category {\n  margin-bottom: 1.5rem;\n}\n\n.suggestion-category h5 {\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  color: #4b5563;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.suggestion-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f3f4f6;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  margin-bottom: 0.5rem;\n}\n\n.suggestion-item p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #4b5563;\n  flex: 1;\n}\n\n.apply-suggestion-button {\n  background-color: #10b981;\n  color: white;\n  border: none;\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.apply-suggestion-button:hover {\n  background-color: #059669;\n}\n\n.uncovered-requirements {\n  margin-top: 1.5rem;\n}\n\n.requirements-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.requirement-item {\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.requirement-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.requirement-header h5 {\n  margin: 0;\n  font-size: 1rem;\n  color: #1f2937;\n}\n\n.requirement-item .action-link {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.requirement-item .action-link:hover {\n  background-color: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n  color: white;\n}\n\n.requirement-item .action-link:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.requirement-item .action-link::before {\n  content: '\\f0ae';  /* Font Awesome icon code for tasks */\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900;\n  margin-right: 0.5rem;\n  font-size: 0.875rem;\n}\n\n/* Generate Test Cases Button Styles */\n.action-link {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-link:hover {\n  background-color: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.action-link:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.action-link::before {\n  content: '\\f0ae';  /* Font Awesome icon code for tasks */\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900;\n  margin-right: 0.5rem;\n  font-size: 0.875rem;\n}\n\n/* No Project Message Styles */\n.no-project-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n  border: 1px dashed #d1d5db;\n  margin: 2rem 0;\n  text-align: center;\n}\n\n.message-icon {\n  font-size: 2.5rem;\n  color: #9ca3af;\n  margin-bottom: 1rem;\n}\n\n.no-project-message h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #4b5563;\n  margin-bottom: 0.5rem;\n}\n\n.no-project-message p {\n  color: #6b7280;\n  max-width: 400px;\n  font-size: 0.875rem;\n}\n\n/* Project Selector Styles */\n.project-selector {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 0.75rem 1rem;\n  background-color: var(--surface-2, #f9fafb);\n  border-radius: 0.5rem;\n  border: 1px solid var(--border, #e5e7eb);\n}\n\n.project-selector label {\n  font-weight: 500;\n  color: var(--text-secondary, #4b5563);\n  flex-shrink: 0;\n}\n\n.project-select {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  border: 1px solid #d1d5db;\n  background-color: white;\n  font-size: 0.875rem;\n  min-width: 200px;\n  color: #1f2937;\n  cursor: pointer;\n}\n\n.project-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);\n}\n\n.project-picker {\n  position: relative;\n  flex: 1;\n  min-width: 240px;\n  max-width: 420px;\n}\n\n.project-picker__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 40px;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--border, #d1d5db);\n  background: var(--surface, #fff);\n  color: var(--text-primary, #1f2937);\n  font-size: 0.875rem;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.project-picker__trigger.is-open,\n.project-picker__trigger:focus-visible {\n  outline: none;\n  border-color: var(--primary, #3b82f6);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary, #3b82f6) 25%, transparent);\n}\n\n.project-picker__value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.project-picker__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--text-muted, #6b7280);\n  flex-shrink: 0;\n}\n\n.project-picker__clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  color: var(--text-muted, #6b7280);\n}\n\n.project-picker__clear:hover {\n  background: color-mix(in srgb, var(--text-primary, #0f172a) 8%, transparent);\n  color: var(--text-primary, #111827);\n}\n\n.project-picker__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 40;\n  background: var(--surface, #fff);\n  border: 1px solid var(--border, #e5e7eb);\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.14);\n  overflow: hidden;\n}\n\n.project-picker__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border, #e5e7eb);\n  color: var(--text-muted, #6b7280);\n}\n\n.project-picker__search input {\n  flex: 1;\n  min-width: 0;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: var(--text-primary, #111827);\n  padding: 0 !important;\n}\n\n.project-picker__search input[type='search']::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.project-picker__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 11px;\n  color: var(--text-muted, #6b7280);\n  border-bottom: 1px solid var(--border-subtle, #f1f5f9);\n}\n\n.project-picker__scope {\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  font-size: 10px;\n}\n\n.project-picker__list {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 6px;\n}\n\n.project-picker__option {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  color: var(--text-primary, #111827);\n}\n\n.project-picker__option:hover,\n.project-picker__option.is-active {\n  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);\n}\n\n.project-picker__option-name {\n  font-size: 0.875rem;\n  font-weight: 550;\n}\n\n.project-picker__option-desc {\n  font-size: 11px;\n  color: var(--text-muted, #6b7280);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.project-picker__empty {\n  padding: 16px 10px;\n  text-align: center;\n  font-size: 0.8125rem;\n  color: var(--text-muted, #6b7280);\n}\n\n.project-picker__retry {\n  margin-left: 8px;\n  border: none;\n  background: transparent;\n  color: var(--primary, #2563eb);\n  cursor: pointer;\n  font-size: 0.8125rem;\n  font-family: inherit;\n  text-decoration: underline;\n}\n\n.selected-project-info {\n  margin-left: 1rem;\n  padding-left: 1rem;\n  border-left: 1px solid #e5e7eb;\n}\n\n.project-description {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.optimization-container {\n  padding: 1.5rem;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.optimization-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.optimization-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #3b82f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  margin-right: 1rem;\n}\n\n.optimization-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.tab-container {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 1.5rem;\n}\n\n.tab-button {\n  padding: 0.75rem 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  background: none;\n  transition: all 0.2s;\n}\n\n.tab-button.active {\n  color: #3b82f6;\n  border-bottom: 2px solid #3b82f6;\n}\n\n.tab-button:not(.active) {\n  color: #6b7280;\n}\n\n.tab-button:hover:not(.active) {\n  color: #4b5563;\n  background-color: #f9fafb;\n}\n\n.tab-content {\n  padding: 1rem 0;\n}\n\n.section-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #1f2937;\n}\n\n.control-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.threshold-control {\n  display: flex;\n  align-items: center;\n}\n\n.threshold-label {\n  margin-right: 0.5rem;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.threshold-value {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.analyze-button {\n  padding: 0.5rem 1rem;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.analyze-button:hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.analyze-button:disabled {\n  background-color: #93c5fd;\n  cursor: not-allowed;\n}\n\n.content-panel {\n  background-color: #f9fafb;\n  padding: 1rem;\n  border-radius: 0.5rem;\n}\n\n.info-text {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.duplicate-group {\n  margin-bottom: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.duplicate-header {\n  background-color: #f3f4f6;\n  padding: 0.5rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.duplicate-title {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.similarity-badge {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-left: 0.5rem;\n}\n\n.merge-button {\n  padding: 0.25rem 0.75rem;\n  background-color: #10b981;\n  color: white;\n  border: none;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.merge-button:hover {\n  background-color: #059669;\n}\n\n.test-case-item {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--border, #e5e7eb);\n}\n\n.test-case-item:last-child {\n  border-bottom: none;\n}\n\n/* Scope hover to optimization page only — do not bleach modal cards in dark mode */\n.optimization-container .test-case-item:hover,\n.mapping-results .test-case-item:hover {\n  background-color: var(--surface-hover, #f9fafb);\n}\n\n.test-case-title {\n  font-weight: 500;\n  color: var(--text-primary, #1f2937);\n}\n\n.test-case-id {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 2rem 0;\n  color: #6b7280;\n}\n\n/* Coverage Analysis Styles */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.stat-card {\n  background-color: white;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.stat-value {\n  font-size: 1.875rem;\n  font-weight: 700;\n}\n\n.stat-value.primary {\n  color: #3b82f6;\n}\n\n.stat-value.success {\n  color: #10b981;\n}\n\n.stat-value.warning {\n  color: #f59e0b;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.progress-item {\n  margin-bottom: 0.5rem;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n}\n\n.progress-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.progress-value {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.progress-bar-bg {\n  width: 100%;\n  height: 0.5rem;\n  background-color: #e5e7eb;\n  border-radius: 9999px;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: 9999px;\n}\n\n.progress-bar-fill.high {\n  background-color: #10b981;\n}\n\n.progress-bar-fill.medium {\n  background-color: #f59e0b;\n}\n\n.progress-bar-fill.low {\n  background-color: #ef4444;\n}\n\n/* User Story Relationship Styles */\n.story-card {\n  margin-bottom: 1.5rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.story-header {\n  background-color: #eff6ff;\n  padding: 1rem;\n}\n\n.story-title {\n  font-weight: 500;\n  color: #1e40af;\n}\n\n.story-description {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n.story-content {\n  padding: 1rem;\n}\n\n.related-tests-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: #1f2937;\n}\n\n.related-tests-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.related-test-item {\n  background-color: white;\n  padding: 0.75rem;\n  border-radius: 0.25rem;\n  border: 1px solid #e5e7eb;\n}\n\n.related-test-title {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.related-test-meta {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n  display: flex;\n  align-items: center;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 9999px;\n  line-height: 1.25rem;\n}\n\n.status-badge.passed {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.priority-label {\n  margin-left: 0.5rem;\n}\n\n/* Table Styles */\n.table-container {\n  background-color: white;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n}\n\n.table {\n  min-width: 100%;\n  border-collapse: collapse;\n}\n\n.table-header {\n  background-color: #f9fafb;\n}\n\n.table-header-cell {\n  padding: 0.75rem 1.5rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.table-row {\n  border-top: 1px solid #e5e7eb;\n}\n\n.table-cell {\n  padding: 1rem 1.5rem;\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n\n.table-cell.primary {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.table-cell.secondary {\n  color: #6b7280;\n}\n\n/* Generate Test Cases button in table */\n.table-cell .action-link {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.table-cell .action-link:hover {\n  background-color: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n  color: white;\n}\n\n.table-cell .action-link:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.table-cell .action-link::before {\n  content: '\\f0ae';  /* Font Awesome icon code for tasks */\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900;\n  margin-right: 0.5rem;\n  font-size: 0.875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
